// extracted by mini-css-extract-plugin
module.exports = {"container":"DOBT9","slider":"IxaXn","slider__slide":"_3eCN8","slider--in-first":"ooDYk","slider--in-last":"YCZqc","sidebar-business-link":"_7qK4r","sidebar-link":"fVDOR"};